/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_SubmitInputs */

const en_idea_submit = /** @type {(inputs: Idea_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const id_idea_submit = /** @type {(inputs: Idea_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjut`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Idea_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_submit = /** @type {((inputs?: Idea_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_submit(inputs)
	return en_idea_submit(inputs)
});